<template>
  <v-row no-gutters>
    <v-btn class="d-flex justify-space-around std-btn-back button-container"
           block
           color="#FFFFFF"
           depressed>
      <div class="d-flex justify-space-between align-center">
        <i class="std-cow-icon std-back-icon mr-4"></i>
        <div class="hidden-xs-only">Regresar</div>
      </div>
    </v-btn>
  </v-row>
</template>

<script>
    export default {
        name: "BackButton"
    }
</script>

<style scoped>
  .button-container {
    height: 40px;
  }
</style>